import { render, staticRenderFns } from "./service-locations-disclaimers-card-edit.vue?vue&type=template&id=a3b9f76c&scoped=true&"
import script from "./service-locations-disclaimers-card-edit.vue?vue&type=script&lang=js&"
export * from "./service-locations-disclaimers-card-edit.vue?vue&type=script&lang=js&"
import style0 from "./service-locations-disclaimers-card-edit.vue?vue&type=style&index=0&id=a3b9f76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b9f76c",
  null
  
)

export default component.exports